import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DashHeader from '../components/DashHeader';
import DashSide from '../components/DashSide';

const Get = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooks = () => {
      try {
        axios.get('https://cacityofgod.pythonanywhere.com/citizen/get_book/')
          .then((response) => {
            setBooks(response.data);
            setLoading(false);
          })
      } catch (error) {
        console.error('Failed to fetch books', error);
        setLoading(false);
      }
    };

    fetchBooks();
  }, []);

  const handleDelete = async (title) => {
    try {
      await axios.delete('https://cacityofgod.pythonanywhere.com/citizen/delete_book/', {
        data: { title }
      });
      setBooks(books.filter((book) => book.title !== title));
    } catch (error) {
      console.error('Failed to delete book', error);
    }
  };

  const handleEdit = (title) => {
    const bookToEdit = books.find(book => book.title === title);
    if (!bookToEdit) return;

    const newTitle = prompt('Enter new title:', bookToEdit.title);
    const newCoverUrl = prompt('Enter new book cover URL:', bookToEdit.book_cover_url);
    const newBookUrl = prompt('Enter new book URL:', bookToEdit.book_url);

    const updatedBook = {
      title: bookToEdit.title,
      new_title: newTitle || bookToEdit.title,
      book_cover_url: newCoverUrl || bookToEdit.book_cover_url,
      book_url: newBookUrl || bookToEdit.book_url,
    };

    axios.put('https://cacityofgod.pythonanywhere.com/citizen/edit_book/', updatedBook)
      .then((response) => {
        setBooks(books.map(book => book.title === title ? response.data : book));
      })
      .catch((error) => {
        console.error('Failed to update book', error);
      });
  };



  return (
    <div className="w-screen h-screen bg-gray-100 flex">
      <div className="fixed top-0 left-0 w-full">
        <DashHeader />
      </div>
      <div className="fixed top-16 left-0 h-screen">
        <DashSide />
      </div>
      <div className="flex-grow p-8 ml-64 mt-16">
        <h2 className="text-2xl font-bold mb-6">All Books</h2>
        {loading ? (
          <p>Loading books...</p>
        ) : (
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr>
                <th className="px-4 py-2 border-b">Title</th>
                <th className="px-4 py-2 border-b">Book Cover URL</th>
                <th className="px-4 py-2 border-b">Book URL</th>
                <th className="px-4 py-2 border-b">Actions</th>
              </tr>
            </thead>
            <tbody>
              {books.map((book) => (
                <tr key={book.id}>
                  <td className="px-4 py-2 border-b">{book.title}</td>
                  <td className="px-4 py-2 border-b">{book.book_cover_url}</td>
                  <td className="px-4 py-2 border-b">{book.book_url}</td>
                  <td className="px-4 py-2 border-b">
                    <button 
                      onClick={() => handleEdit(book.title)} 
                      className="text-blue-500 hover:text-blue-700 mr-4"
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDelete(book.title)} 
                      className="text-red-500 hover:text-red-700"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Get;

